import { Component, OnInit } from '@angular/core';
import { CookieService } from 'ngx-cookie';
import { Router } from '@angular/router';
import { environment } from 'environments/environment';
import { DynamicDialogRef, DynamicDialogConfig, DialogService } from 'primeng/dynamicdialog';
import { HTTPService } from '../../../services/http.service';
import { HelperService } from '../../../services/helper.service';
import { DataService } from '../../../services/data.service';

@Component({
  selector: 'app-trial-campaign-dialog',
  templateUrl: './trial-campaign-dialog.component.html',
  styleUrls: ['./trial-campaign-dialog.component.scss'],
})
export class TrialCampaignDialogComponent implements OnInit {
  campaignType: string = '';
  showSubscribeText: boolean = false;
  remainingCount: any = {};
  appsettings: any = {};
  remainingFollowup: any = 0;
  remainingPromotional: any = 0;
  isIntercomSetupDone: boolean = false;

  campaignPropmotional: any = [
    { title: 'Create delightful content', description: "Add a personal touch without the personal effort through AutoLeap's email builders", src: '../../../../assets/img/icon1.png' },
    { title: 'Announce limited discounts', description: 'Create a loyal customer base by offering targeted discounts to your most valuable users', src: '../../../../assets/img/icon2.png' },
    { title: 'Promote products & services', description: 'Increase sales by highlighting the best or unique services you offer to your clients', src: '../../../../assets/img/icon3.png' },
    {
      title: 'See your revenue grow',
      description: 'With all your data and insights in one place, AutoLeap makes it easy to see what’s working best for you.',
      src: '../../../../assets/img/icon4.png',
    },
  ];

  campaignFollowup: any = [
    { title: 'Increase customer engagement', description: '5% increase in customer retention can increase company revenue by 25-95%', src: '../../../../assets/img/icon5.png' },
    { title: 'Bring in more repeat customers', description: 'Grow your loyal customer base by many manifolds and become the go-to shop of your neighborhood', src: '../../../../assets/img/icon6.png' },
    {
      title: 'See your revenue grow',
      description: 'With all your data and insights in one place, AutoLeap makes it easy to see what’s working best for you.',
      src: '../../../../assets/img/icon4.png',
    },
  ];

  constructor(
    public ref: DynamicDialogRef,
    public dConfig: DynamicDialogConfig,
    public dialogService: DialogService,
    private httpService: HTTPService,
    private helperService: HelperService,
    public dataService: DataService,
    private cookieService: CookieService,
    private router: Router
  ) {}

  ngOnInit() {
    const data = this.dConfig.data;
    if (data) {
      this.campaignType = data.campaignType;
      this.showSubscribeText = data.showSubscribeText ? data.showSubscribeText : false;
    }

    this.makeTokenData();
    this.getSettings();
  }

  getSettings() {
    const { companyId } = this.helperService.getCompany();

    this.httpService.getCompanySettings(companyId).then(
      (response) => {
        this.dataService.marketingSettings = response.appsettings.marketingSettings;
        this.appsettings = response.appsettings;
        this.remainingCount = this.appsettings.marketingSettings;
        this.remainingPromotional = this.remainingCount.promotionLimit - this.remainingCount.usedPromotions;
        this.remainingFollowup = this.remainingCount.followUpLimit - this.remainingCount.usedFollowUps;
      },
      (error) => {
        console.log(error);
      }
    );
  }

  makeTokenData() {
    if (this.isIntercomSetupDone) return;
    this.isIntercomSetupDone = true;

    const token = this.cookieService.getObject('alpat');

    if (token) {
      const data: any = this.helperService.jwtDecode(token);
      const companyData: any = {};

      if (this.dataService.company.externalId) {
        if (this.dataService.company) {
          companyData.id = this.dataService.company.externalId;
          companyData.name = this.dataService.company.name;
          companyData.website = this.dataService.company.website;
          companyData['Primary Contact'] = this.dataService.company.phone;
          companyData.custom_attributes = {
            'Primary Contact': this.dataService.company.phone,
            'Primary contact': this.dataService.company.phone,
            primary_contact: this.dataService.company.phone,
          };
        }
      }

      if (data) {
        (<any>window).Intercom('boot', {
          app_id: environment.APP_ID,
          name: data.fullName,
          email: data.userName,
          phone: data.otherUserName,
          permission: data.role,
          customer: data.name,
          company_email: data.email,
          url: this.router.url,
          alignment: 'right',
          custom_launcher_selector: '#intercom-chat',
          horizontal_padding: 100,
          vertical_padding: 0,
          hide_default_launcher: true,
          company: companyData,
        });
        (<any>window).Intercom('onShow', function () {
          const myCustomMessage = 'Hey! I would like to know more about AutoLeap Marketing';
          (<any>window).Intercom('showNewMessage', myCustomMessage);
        });
        return data;
      }
    }

    return {};
  }

  progressPercentage(value, averageValue) {
    const percentage = this.getPercentage(value, averageValue);
    const width = percentage > 100 ? Math.round((100 / percentage) * 100) : percentage;

    if (isNaN(width) || !isFinite(width)) {
      return `${0}%`;
    } else {
      return `${width}%`;
    }
  }

  getPercentage(value, averageValue) {
    const percentage = Math.round((Math.round(value) / Math.round(averageValue)) * 100);

    if (isNaN(percentage) || !isFinite(percentage)) {
      return 0;
    } else {
      return percentage;
    }
  }

  showIntercom() {
    (<any>window).Intercom('show');
  }

  close() {
    this.ref.close();
  }
}
